import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard-tiles",
  "use": "dashboard-tiles-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dashboard-tiles\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <polygon points=\"0 0 24 0 24 24 0 24\" />\n    <path fill=\"#677078\" fill-rule=\"nonzero\" d=\"M3,13 L11,13 L11,3 L3,3 L3,13 Z M3,21 L11,21 L11,15 L3,15 L3,21 Z M13,21 L21,21 L21,11 L13,11 L13,21 Z M13,3 L13,9 L21,9 L21,3 L13,3 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol